import React, {useEffect, useMemo, useState} from 'react';
import {Container} from "reactstrap";
import {useAsyncDebounce} from "react-table";
import {CommonValue} from "../Parties/PartiesCol";
import {Edit} from "../Settings/SettingsCol";
import SubscriptionsTable from "./components/SubscriptionsTable";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {getSubscriptionsSummary} from "../../store/Subscriptions/actions";
import TfBreadcrumbs from "../../components/Common/TfBreadcrumbs";
import {SubscriberBreadcrumb, SubscriptionBreadcrumb} from "../../common/data/parties";


const Subscriptions = () => {
    const [value, setValue] = useState('');
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(0);
    const [previewModal, setPreviewModal] = useState(false);
    const { subscriptions_data } = useSelector((state) => state.subscriptionsReducer);
    const dispatch = useDispatch();

    const onChange = useAsyncDebounce(value => {
        //console.log(value);
    }, 200);

    useEffect(() => {
        if (currentPage !== '' && currentPage !== undefined) {
            let url = `?page=${currentPage}&size=10`;
            dispatch(getSubscriptionsSummary(url));
        }
    }, [dispatch, currentPage])

    const viewPopupHandler = (data) => {
    }

    const editHandler = (data) => {
        //console.log(data, "data");
        navigate(`/network/edit/subscriptions`, {
            state: {
                id: data.id || '',
                data: data
            },
        });
    }
    const subscriptionsColumns = useMemo(
        () => [
            {
                Header: "Subscription Code",
                accessor: "subscriptionCode",
                filterable: true,
                disableFilters: true,
                Cell: (cellProps) => {
                    return (
                        <CommonValue
                            cellProps={cellProps}
                            viewPopupHandler={viewPopupHandler}
                        />
                    );
                },
            },
            {
                Header: "Subscription Name",
                accessor: "subscriptionName",
                filterable: true,
                disableFilters: true,
                Cell: (cellProps) => {
                    return (
                        <CommonValue
                            cellProps={cellProps}
                            viewPopupHandler={viewPopupHandler}
                        />
                    );
                },
            },
            {
                Header: "No. Of Modules",
                accessor: "noOfModules",
                filterable: true,
                disableFilters: true,
                Cell: (cellProps) => {
                    return (
                        <CommonValue
                            cellProps={cellProps}
                            viewPopupHandler={viewPopupHandler}
                        />
                    );
                },
            },
            {
                Header: "Payment",
                accessor: "payment",
                filterable: true,
                disableFilters: true,
                Cell: (cellProps) => {
                    return (
                        <CommonValue
                            cellProps={cellProps}
                            viewPopupHandler={viewPopupHandler}
                        />
                    );
                },
            },
            {
                Header: "Subscriptions Amount",
                accessor: "subscriptionAmount",
                filterable: true,
                disableFilters: true,
                Cell: (cellProps) => {
                    return (
                        <CommonValue
                            cellProps={cellProps}
                            viewPopupHandler={viewPopupHandler}
                        />
                    );
                },
            },
            {
                Header: "Is Invite By",
                accessor: "isInvitedBy",
                filterable: true,
                disableFilters: true,
                Cell: (cellProps) => {
                    if (cellProps.row.original?.isInvitedBy) {
                        return (
                            <i className="bx bx-check-double"></i>
                        );
                    } else {
                        return (
                            <i className="bx bx-minus"></i>
                        );
                    }
                },
            },
            {
                Header: "IsDefault",
                accessor: "isDefault",
                filterable: true,
                disableFilters: true,
                Cell: (cellProps) => {
                    if (cellProps.row.original?.isDefault) {
                        return (
                            <i className="bx bx-check-double"></i>
                        );
                    } else {
                        return (
                            <i className="bx bx-minus"></i>
                        );
                    }
                },
            },
            {
                Header: "Industry Type",
                accessor: "industryType",
                filterable: true,
                disableFilters: true,
                Cell: (cellProps) => {
                    return (
                        <CommonValue
                            cellProps={cellProps}
                            viewPopupHandler={viewPopupHandler}
                        />
                    );
                },
            },
            {
                Header: "Action",
                accessor: "action",
                filterable: true,
                disableFilters: true,
                Cell: (cellProps) => {
                    return (
                        <div className="d-flex justify-content-start align-items-start h-100">
                            <p style={{marginTop: "15px"}}>
                                <Edit cellProps={cellProps} viewPopupHandler={editHandler} />
                            </p>
                        </div>
                    );
                },
            }
        ], []);

    const previewModalHand = () => {
        setPreviewModal(!previewModal);
    }

    return (
        <>
            <div className="page-content settings_users_wrapper">
                <Container fluid>
                    <div className="main_freight_wrapper">
                        <div className="tf_top_breadcrumb_rate_wrap">
                            <TfBreadcrumbs breadcrumb={SubscriptionBreadcrumb}/>
                        </div>

                        <SubscriptionsTable
                            columns={subscriptionsColumns}
                            data={subscriptions_data?.content || []}
                            isGlobalFilter={true}
                            customPageSize={10}
                            component={"Subscriptions"}
                            loader={false}
                            setCurrentPage={setCurrentPage}
                            totalPages={subscriptions_data?.totalPages || 0}
                            totalEntries={subscriptions_data?.totalElements || 0}
                        />
                    </div>
                </Container>
            </div>
        </>
    )
}

export default Subscriptions;
